import React from 'react'
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function FootPrint({data}) {

  return (
    <div className='bs-foot-print'>
        <ul className='bs-foot-print__list-wrap'>
            {data.map((item, index) => {
                return (
                    <li className='bs-foot-print__list-item' key={index}>
                        <div className='bs-foot-print__tile'>
                            <div className='bs-foot-print__media-wrap'>
                                <CloudinaryAdvancedImage imagePublicId={item.imgId} className='bs-foot-print__image' type="section-feature-image" />
                            </div>
                            <div className='bs-foot-print__info-wrap'>
                                <h3 className='bs-foot-print__info-title' dangerouslySetInnerHTML={{__html: item.title}}></h3>
                                <p className='bs-foot-print__info-desc' dangerouslySetInnerHTML={{__html: item.info}}></p>
                            </div>
                        </div>
                    </li>
                )
            })}
        </ul>
    </div>
  )
}

export default FootPrint